/**
 * @ignore
 */
function pad(num: number, digits: number): string {
  let numStr: string = num.toString();
  while (numStr.length < digits) {
    numStr = `0${numStr}`;
  }

  return numStr;
}

/**
 * Returns as 'YYYY-MM-DD HH:MM:SS.FFF' format
 *
 * @param {date} date - A date object.
 * @ignore
 */
export function isoFormat(date: Date): string {
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1, 2); // Months are zero-indexed
  const day = pad(date.getDate(), 2);
  const hour = pad(date.getHours(), 2);
  const minute = pad(date.getMinutes(), 2);
  const second = pad(date.getSeconds(), 2);
  const msecond = pad(date.getMilliseconds(), 3);

  return `${year}-${month}-${day} ${hour}:${minute}:${second}.${msecond}`;
}
